export default "__VITE_ASSET__6f6ea5e5__"